// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"Treatment_gridContainer__2YmjW"};